import Reveal from './Reveal';

export default function CtaSection() {
  return (
    <section className="py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="relative rounded-lg overflow-hidden border border-background-200">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm%20magazine%20spread%20background%20with%20layered%20cream%20and%20terracotta%20paper%20textures%2C%20soft%20folded%20fabric%20and%20shadow%20shapes%2C%20subtle%20rose%20accent%20lines%2C%20minimal%20editorial%20still%20life%2C%20gentle%20natural%20light%2C%20calm%20harmonious%20refined%20mood%2C%20no%20text&width=1200&height=800&seq=dolly-cover-02&orientation=landscape"
                alt="专题合集阅读氛围配图"
                title="玩偶姐姐 · 专题合集"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/75 via-foreground-950/55 to-foreground-950/70"></div>

            <div className="relative px-6 py-14 md:px-14 md:py-20 text-center">
              <span className="text-xs tracking-[0.3em] text-background-200 uppercase">Read The Collection</span>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-background-50 max-w-2xl mx-auto leading-snug">
                想按顺序把资料读一遍？从目录开始最快
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-100/90 max-w-xl mx-auto leading-relaxed">
                整页内容按「认识人 → 看出道 → 查身份」的逻辑排好了顺序，回到索引即可逐段阅读。
              </p>
              <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                <a
                  href="#index"
                  className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  回到专题索引
                </a>
                <a
                  href="#faq"
                  className="px-6 py-3 rounded-md border border-background-200/70 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
                >
                  看看常见问答
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}